import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Btn from '../../Btn';
import config from '../../../config';
import authHeaders from '../../../utilities/authHeaders';
import { useStore } from '../../../StoreProvider';
import { ACTIONS } from '../../../Actions';
import convertJSON from '../../../utilities/convertJSON';

const LibertyTire = ({freightRules, markup}) => {
    const { state, dispatch } = useStore();
    const [lt_price_per_tons, set_lt_price_per_tons] = useState(freightRules.libertyTire_price_per_tons);
    const [lt_fixed_cost, set_lt_fixed_cost] = useState(freightRules.libertyTire_fixed_cost);
    const headers = authHeaders(state?.auth.accessToken, state?.auth.refreshToken);

    const libertyTire = {
        title: 'Liberty Tire',
        names: ['Manufacturer', 'Price Per Tons', 'Fixed Cost', 'Freight Markup'],
    };
    const colSpanLength = libertyTire.names.length;

    let idArray = ['libertyTire_price_per_tons', 'libertyTire_fixed_cost'];

    let putBody = {};

    // API call for posting quote into our database
    const putInput = async () => {
        for (let e = 0; e < idArray.length; e++) {
            var inputID = idArray[e];
            var inputValue = document.getElementById(inputID).value;

            putBody[inputID] = inputValue;
        }

        try {
            const res = await fetch(`${config.base_api}/freightRules`, {
                method: 'PUT',
                headers,
                body: JSON.stringify(putBody),
            });

            await convertJSON(res);

            dispatch({ type: ACTIONS.TOAST, payload: {message: 'Liberty Tire Updated'}});
        } catch (error) {
            console.log(error);
            dispatch({ type: ACTIONS.TOAST, payload: {message: error, isError: true}});
        }
    };

    return (
        <form className="freightGroup">
            <div className="quotesTable">
                <table>
                    <thead>
                        <tr>
                            {libertyTire.names.map((name) => (
                                <th>{name}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{libertyTire.title}</td>
                            <td>
                                <input
                                    id="libertyTire_price_per_tons"
                                    defaultValue={lt_price_per_tons}
                                    onChange={(e) => set_lt_price_per_tons(e.target.value)}></input>
                            </td>
                            <td>
                                <input
                                    id="libertyTire_fixed_cost"
                                    defaultValue={lt_fixed_cost}
                                    onChange={(e) => set_lt_fixed_cost(e.target.value)}></input>
                            </td>
                            <td>
                                <input value={markup} disabled="true"></input>
                            </td>
                        </tr>
                        <tr className="equation">
                            <td colspan={colSpanLength}>
                                Calculation: <br />
                                ((Tons X ${lt_price_per_tons}) + ${lt_fixed_cost}) / {markup}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <Btn title="Update" onClick={putInput} 
                btnClass = 'blue-button b2-blue text-white bg-blue text-bold box-shadow pad-tb-sm'/>
            </div>
        </form>
    );
};

export default LibertyTire;
